import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from '../Field.js';
import connectForm$1 from '../../../cinnamon-core/es/components/forms/connectForm.js';
import { FormChangeSource } from '../../../cinnamon-core/es/components/forms/constants.js';
import ITypeAhead from '../../inputs/TypeAhead.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { prettifyField, omitProps, fieldErrors } from '../../../cinnamon-core/es/components/forms/utils.js';
import { requiredField } from '../../../cinnamon-core/es/components/forms/validators/requiredField.js';

var _templateObject;
var componentRoot = createComponentSlot({
  name: "CinFormTypeAhead",
  slot: "Root"
});

var TypeAheadBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TypeAheadBase, _React$Component);

  var _super = _createSuper(TypeAheadBase);

  function TypeAheadBase() {
    var _this;

    _classCallCheck(this, TypeAheadBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "extractValueField", function (value) {
      var multiple = _this.props.multiple;

      if (value) {
        var selectedValues = Array.isArray(value) ? value : [value];
        var val = selectedValues.map(function (v) {
          return typeof v === "string" ? v : v === null || v === void 0 ? void 0 : v.value;
        });
        return !multiple && val.length === 1 ? val[0] : val;
      } else {
        return !multiple && value === null ? null : undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "valueFieldEquals", function (extractedValue, currentValue) {
      return extractedValue === currentValue || // check each value in a 'multiple' field matches
      Array.isArray(extractedValue) && Array.isArray(currentValue) && extractedValue.length === currentValue.length && extractedValue.every(function (v, i) {
        return _this.valueFieldEquals(v, currentValue[i]);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          valueField = _this$props.valueField,
          syncValueFieldOnMount = _this$props.syncValueFieldOnMount,
          formState = _this$props.formState;

      if (syncValueFieldOnMount && valueField && value) {
        // if valueField specified store the selected value
        var extractedValue = _this.extractValueField(value);

        var currentValue = formState.fields[valueField]; // skip if form up-to-date

        if (!_this.valueFieldEquals(extractedValue, currentValue)) {
          var additionalFormData = _defineProperty({}, valueField, extractedValue);

          _this.props.onChange(value, additionalFormData, {
            source: FormChangeSource.Field,
            valueField: valueField
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          valueField = _this$props2.valueField,
          syncValueFieldOnUpdate = _this$props2.syncValueFieldOnUpdate,
          formState = _this$props2.formState;

      if (syncValueFieldOnUpdate && valueField && value !== prevProps.value) {
        // if valueField specified store the selected value
        var extractedValue = _this.extractValueField(value);

        var currentValue = formState.fields[valueField]; // skip if form up-to-date

        if (!_this.valueFieldEquals(extractedValue, currentValue)) {
          var additionalFormData = _defineProperty({}, valueField, extractedValue);

          _this.props.onChange(value, additionalFormData, {
            source: FormChangeSource.Field,
            valueField: valueField
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event, value) {
      var valueField = _this.props.valueField;

      if (valueField) {
        // if valueField specified store the selected value
        var extractedValue = _this.extractValueField(value);

        var additionalFormData = _defineProperty({}, valueField, extractedValue);

        _this.props.onChange(value, additionalFormData);

        return;
      }

      _this.props.onChange(value);
    });

    return _this;
  }

  _createClass(TypeAheadBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var multiple = this.props.multiple;
      var _this$props3 = this.props,
          _this$props3$value = _this$props3.value,
          value = _this$props3$value === void 0 ? multiple ? [] : null : _this$props3$value;
          _this$props3.onChange;
          var errors = _this$props3.errors,
          showErrors = _this$props3.showErrors,
          allErrors = _this$props3.allErrors,
          animateErrors = _this$props3.animateErrors,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          renderReadOnly = _this$props3.renderReadOnly,
          label = _this$props3.label,
          labelProps = _this$props3.labelProps,
          actions = _this$props3.actions,
          width = _this$props3.width,
          fluid = _this$props3.fluid,
          required = _this$props3.required,
          passThruProps = _this$props3.passThruProps;
          _this$props3.valueField;
          var forwardedRef = _this$props3.forwardedRef,
          className = _this$props3.className;
      var otherProps = omitProps(passThruProps, Object.keys(TypeAheadBase.propTypes));

      var fieldLabelProps = _objectSpread2({
        variant: readOnly && renderReadOnly ? "field" : "input"
      }, labelProps);

      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && renderReadOnly ? function () {
          return renderReadOnly(_this2.props);
        } : false,
        width: width,
        fluid: fluid,
        label: fieldLabelProps.variant === "input" ? undefined : label,
        labelProps: fieldLabelProps,
        actions: actions,
        errors: fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors,
        className: classnames(componentRoot.className, className),
        ref: forwardedRef
      }, /*#__PURE__*/React.createElement(ITypeAhead, _extends({}, otherProps, {
        value: value,
        onChange: this.onChange,
        label: fieldLabelProps.variant === "input" ? label : undefined,
        readOnly: readOnly,
        disabled: disabled
      })));
    }
  }]);

  return TypeAheadBase;
}(React.Component);

_defineProperty(TypeAheadBase, "propTypes", {
  notifiedFields: propTypes.arrayOf(propTypes.string),
  customValidator: propTypes.func,
  customErrors: propTypes.arrayOf(propTypes.string),
  readOnly: propTypes.bool,
  disabled: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  allErrors: propTypes.bool,
  showErrors: propTypes.bool,
  field: propTypes.string.isRequired,
  requiredError: propTypes.string,
  required: propTypes.bool,
  variant: propTypes.any,
  sx: propTypes.any,
  className: propTypes.string,
  syncValueFieldOnUpdate: propTypes.bool,
  syncValueFieldOnMount: propTypes.bool,
  valueField: propTypes.string,
  renderReadOnly: propTypes.func,
  fluid: propTypes.bool,
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  actions: propTypes.node,
  labelProps: propTypes.any
});

_defineProperty(TypeAheadBase, "defaultProps", {
  onChange: function onChange() {}
});

var ConnectedTypeAhead = connectForm$1({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  },
  validators: [requiredField(false)]
})(TypeAheadBase);
var TypeAheadRoot = styled(ConnectedTypeAhead, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
TypeAheadRoot.defaultProps = {
  lookupOptions: {
    cache: true,
    cacheLimit: 5
  },
  debounce: 200,
  alwaysShowSuggestionsOnBlur: false,
  alwaysShowSuggestionsOnMount: true,
  syncValueFieldOnMount: true,
  syncValueFieldOnUpdate: true,
  variant: "outlined"
};
/**
 * Field for a type-ahead search field
 */

var TypeAhead = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(TypeAheadRoot, _extends({}, rootProps, {
    ref: ref
  }));
});
var TypeAhead$1 = TypeAhead;

export { TypeAhead$1 as default };
